import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import { translate as t } from '../../lib/I18n';

function FareClassBadge({ isFirstClass, className }) {
    const baseClass = 'fare__class-badge';
    const fareClassBadge = classnames(className, baseClass, {
        [`${baseClass}--first`]: isFirstClass,
        [`${baseClass}--standard`]: !isFirstClass,
    });

    return (
        <span className={ fareClassBadge }>
            { isFirstClass ? t('booking.fares.details.class.1st') : t('booking.fares.details.class.standard') }
        </span>
    );
}

FareClassBadge.propTypes = {
    isFirstClass: PropTypes.bool.isRequired,
    className: PropTypes.string
};

export default FareClassBadge;

